// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ed77e60","455":"aee1a9bc","977":"fed3fbba"}[chunkId] + ".chunk.js";
};